<div class="flex align-center justify-start gap-10 p-10">
  <app-icon name="warning" size="lg" color="warn" aria-hidden="true"></app-icon>
  <h2 mat-dialog-title class="flex-1" data-testid="save-stalled-title">{{ copy.title }}</h2>
</div>
<mat-dialog-content class="dialog-text" data-testid="save-stalled-body">{{ copy.body }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="primary-btn save-stalled__dismiss" mat-dialog-close data-testid="save-stalled-dismiss">
    {{ copy.dismissLabel }}
  </button>
</mat-dialog-actions>
